/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_StreetInputs */

const cs_projects_street = /** @type {(inputs: Projects_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulice`)
};

const en_projects_street = /** @type {(inputs: Projects_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Street`)
};

/**
* | output |
* | --- |
* | "Street" |
*
* @param {Projects_StreetInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_street = /** @type {((inputs?: Projects_StreetInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_StreetInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_street(inputs)
	return cs_projects_street(inputs)
});